var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-select',{staticClass:"form__select",attrs:{"getPopupContainer":_vm.selectContainer,"default-value":_vm.list[0].value}},_vm._l((_vm.list),function(item,index){return _c('a-select-option',{key:index,attrs:{"value":item.value}},[_vm._v(" "+_vm._s(item.value)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }